import { useState } from 'react';
import { Reveal } from './Reveal';
import { LANDING_SHOWCASE } from '../../domain/landingContent';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

/** Showcase com screenshots do produto (tabs). */
export function LandingShowcase() {
  const [ativo, setAtivo] = useState(0);
  const item = LANDING_SHOWCASE[ativo]!;

  return (
    <section className="mx-auto max-w-6xl px-4 py-24 sm:px-6 sm:py-32">
      <Reveal className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          O produto em ação
        </h2>
        <p className="mt-3 text-sm text-slate-400 sm:text-base">
          TV, celular e futebol integrados — a mesma experiência que seus clientes vão ter no salão.
        </p>
      </Reveal>

      <Reveal delay={0.08} className="mt-10">
        <div
          className="flex flex-wrap justify-center gap-2"
          role="tablist"
          aria-label="Demonstrações do produto"
        >
          {LANDING_SHOWCASE.map((s, i) => (
            <button
              key={s.id}
              type="button"
              role="tab"
              aria-selected={ativo === i}
              aria-controls={`showcase-panel-${s.id}`}
              onClick={() => setAtivo(i)}
              className={`${TRANS} inline-flex min-h-11 items-center rounded-full px-4 text-xs font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50 motion-reduce:transition-none sm:text-sm ${
                ativo === i
                  ? 'bg-orange-500/20 text-orange-300 ring-1 ring-orange-500/30'
                  : 'border border-white/10 bg-white/[0.03] text-slate-400 hover:text-white'
              }`}
            >
              {s.titulo}
            </button>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.12} className="mt-8">
        <figure
          id={`showcase-panel-${item.id}`}
          role="tabpanel"
          className="overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.03] p-2 shadow-2xl shadow-black/40"
        >
          <div className="overflow-hidden rounded-[calc(2rem-0.5rem)] bg-[#0c0c12]">
            <img
              src={item.imageSrc}
              alt={item.imageAlt}
              width={1200}
              height={675}
              loading="lazy"
              decoding="async"
              className="aspect-video w-full object-cover"
            />
          </div>
          <figcaption className="px-4 py-5 text-center sm:px-6">
            <h3 className="text-lg font-semibold text-white">{item.titulo}</h3>
            <p className="mt-2 text-sm text-slate-400">{item.descricao}</p>
          </figcaption>
        </figure>
      </Reveal>
    </section>
  );
}
